/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LookupStyle {
  Simple = 'Simple',
  Advanced = 'Advanced'
}
